// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__gOcjP","label":"Category_label__2cTAT","content":"Category_content__3UCRp","header":"Category_header__2r3nC","location":"Category_location__3Zgn4"};